/* tslint:disable */
/* eslint-disable */

/**
 * 805290000 = Ja (Ja)
 * 
 * 805290001 = Nein (Nein)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceJaNein {
 Ja = 805290000,
 Nein = 805290001
}

marker([
    "Enum.GlobalEnumsAceJaNein.Ja",
    "Enum.GlobalEnumsAceJaNein.Nein"
]);

export namespace GlobalEnumsAceJaNein
{
    class DataSets
    {
        static GlobalEnumsAceJaNeinDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Ja", 805290000, "Ja"),
            new EnumValue("Nein", 805290001, "Nein"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceJaNeinDataSet;
    }
}
